import { useState, useEffect } from "react";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + '/sentinel')}`;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          onClick={() => scrollToSection("hero")}
          className="font-mono text-lg tracking-widest text-[#F3F4F6] hover:text-[#00F0FF] transition-colors duration-300"
        >
          WYCO<span className="text-[#00F0FF]">CAPITAL</span>
        </button>
        
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection("thesis")}
            className="font-sans text-sm text-[#6B7280] hover:text-[#F3F4F6] transition-colors duration-300"
          >
            Thesis
          </button>
          <button
            onClick={() => scrollToSection("leadership")}
            className="font-sans text-sm text-[#6B7280] hover:text-[#F3F4F6] transition-colors duration-300"
          >
            Leadership
          </button>
          <button
            onClick={() => scrollToSection("portfolio")}
            className="font-sans text-sm text-[#6B7280] hover:text-[#F3F4F6] transition-colors duration-300"
          >
            Portfolio
          </button>
          <button
            onClick={() => scrollToSection("contact")}
            className="font-sans text-sm text-[#6B7280] hover:text-[#F3F4F6] transition-colors duration-300"
          >
            Contact
          </button>
          <button
            onClick={handleLogin}
            className="font-mono text-sm px-4 py-2 border border-[#00F0FF]/30 text-[#00F0FF] rounded hover:bg-[#00F0FF]/10 hover:border-[#00F0FF]/60 transition-all duration-300"
          >
            LOGIN
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
